import * as api from 'api/entity-api'
import { retrieveUnitList, retrieveUnitGroup, action } from 'analytics/actions'
import {
  getSelectedUnits,
  getSelectedGroups,
  getGroups,
  getEntityTargetInfo,
  getUnitIds,
  // getFilteredUnitList,
  getYear,
  getUnitMap,
} from 'analytics/selectors'
import Chance from 'chance'
import R from 'ramda'

// import { mockSummaryUnitData, /* mockDetailedUnitData */ } from './mockOutageData'

import { getPeriod /* getMetricDisplayMap,  getMetricRollupMap */ } from './selectors'

import moment from 'moment'

import {
  CHANGE_PERIOD,
  SET_LOADING,
  // STORE_SUM_DATA,
  STORE_DETAIL_DATA,
  // STORE_EFORD_CONTRIB,
  // STORE_AG_EFORD,
  STORE_KPI_SPEC,
  STORE_KPI_AG,
  STORE_KPI_CA_AG,
  STORE_KPI_CONTRIB,
  STORE_KPI_CA_CONTRIB,
  STORE_CONTRIB_KEYS,
  STORE_CA_CONTRIB_KEYS,
  STORE_KPI_GOALS,
  STORE_YEAR,
  STORE_CA_DATA,
  STORE_WEEK_HOUR_DATA,
  SET_SHOW_SELECTOR,
  STORE_GADS_SUMMARIZED_DATA,
  STORE_GADS_MONTHLY_DATA,
  STORE_PNL_WEEKLY_DATA,
} from './action-names'
import { storeErrorAction } from 'core/actions'
import { fromNullable } from 'data.maybe'
const chance = new Chance()

export const changePeriod = period => action(CHANGE_PERIOD, period)
export const changePeriodDispatch = dates => dispatch => {
  const period = {
    from: { year: dates[0].format('YYYY'), month: dates[0].format('MM') },
    to: { year: dates[1].format('YYYY'), month: dates[1].format('MM') },
  }
  dispatch(action(CHANGE_PERIOD, period))
}

// const mockSpec = { min: 20, max: 100, fixed: 3 }
// const keys = ['EFDH', 'EMDH', 'EPDH', 'DEH', 'PDEH', 'EFORD']

// const mockSummary = R.compose(R.map(mockSummaryUnitData(keys, mockSpec)), getUnitIds)

// const toRangeSpec = ({ from, to }) => {
//   const minDate = moment(`${from.year}-${from.month}`, 'YYYY-MM')
//   const maxDate = moment(`${to.year}-${to.month}`, 'YYYY-MM')
//   return { minDate, maxDate, incrementType: 'M' }
// }

const normalizeResults = R.compose(
  R.sort((a, b) => a.date.getTime() - b.date.getTime()),
  R.map(({ date, value, ...rest }) => ({
    date: new Date(date),
    ...rest,
    value: fromNullable(value).getOrElse(0),
  }))
)

export const retrieveUnitData = moment => (dispatch, getState) => {
  dispatch(action(SET_LOADING, true))
  retrieveUnitList(moment)(dispatch, getState)
    .then(() => {
      retrieveUnitGroup()(dispatch, getState)
      dispatch(action(SET_LOADING, false))
    })
    .catch(error => {
      dispatch(action(SET_LOADING, false))
      console.log('error retrieving from server', error)
    })
}

export const retrieveDataByGroup = _ => (dispatch, getState) => {
  const targetInfo = getEntityTargetInfo(getState())
  const period = getPeriod(getState())
  const groups = getSelectedGroups(getState())

  /* eslint-disable no-console */
  dispatch(action(SET_LOADING, true))
  return api
    .getGadsKpiByGroup(targetInfo)(period, groups)
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(({ rawData: raw, summaryData }) => {
      // const rollupMap = getMetricRollupMap(getState())
      const payload = { summaryData, data: normalizeResults(raw) }
      dispatch(action(STORE_DETAIL_DATA, payload))
      dispatch(action(SET_LOADING, false))
    })
    .catch(error => {
      dispatch(action(SET_LOADING, false))
      console.log('error retrieving from server', error)
    })
  /* eslint-enable no-console */
}

export const retrieveDataByUnit = _ => (dispatch, getState) => {
  const targetInfo = getEntityTargetInfo(getState())
  const period = getPeriod(getState())
  const units = getSelectedUnits(getState())
  const groups = getSelectedGroups(getState())

  /* eslint-disable no-console */
  dispatch(action(SET_LOADING, true))
  return api
    .getGadsKpi(targetInfo)(period, units, groups)
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(({ rawData: raw, summaryData }) => {
      // const rollupMap = getMetricRollupMap(getState())
      const payload = { summaryData, data: normalizeResults(raw) }
      dispatch(action(STORE_DETAIL_DATA, payload))
      dispatch(action(SET_LOADING, false))
    })
    .catch(error => {
      dispatch(action(SET_LOADING, false))
      console.log('error retrieving from server', error)
    })
  /* eslint-enable no-console */
}

const mockTrends = R.map(d => ({
  ...d,
  trend: chance.pickone(['up', 'down', 'even']),
}))

const createSimpleRetrieve = (stateToRetrievePromise, storeAction) => _ => (dispatch, getState) => {
  dispatch(action(SET_LOADING, true))
  return stateToRetrievePromise(getState()) /// getCaDataByGroup(targetInfo)(period, groups)
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(d => {
      dispatch(action(SET_LOADING, false))
      dispatch(action(storeAction, mockTrends(d)))
      dispatch(hideSelector())
    })
    .catch(error => {
      dispatch(action(SET_LOADING, false))
      console.log('error retrieving from server', error)
      dispatch(hideSelector())
    })
}

const stateToRequest = apiMethod => state => {
  const targetInfo = getEntityTargetInfo(state)
  const period = getPeriod(state)
  const groups = getSelectedGroups(state)
  const units = getSelectedUnits(state)
  const year = getYear(state)
  return apiMethod(targetInfo)({ period, units, groups, year })
}

export const retrieveCaByGroup = createSimpleRetrieve(
  stateToRequest(api.getCaDataByGroup),
  STORE_CA_DATA
)
export const retrieveCaByUnit = createSimpleRetrieve(
  stateToRequest(api.getCaDataByUnit),
  STORE_CA_DATA
)

export const retrieveGadsSummaryByGroup = createSimpleRetrieve(
  stateToRequest(api.getGadsDataByGroup),
  STORE_GADS_SUMMARIZED_DATA
)
export const retrieveGadsSummaryByUnit = createSimpleRetrieve(
  stateToRequest(api.getGadsDataByUnit),
  STORE_GADS_SUMMARIZED_DATA
)

export const retrieveGadsMonthlyByGroup = createSimpleRetrieve(
  stateToRequest(api.getGadsMonthlyByGroup),
  STORE_GADS_MONTHLY_DATA
)

export const retrieveGadsMonthlyByUnit = createSimpleRetrieve(
  stateToRequest(api.getGadsMonthlyByUnit),
  STORE_GADS_MONTHLY_DATA
)

export const retrieveWeeklyLossRevData = createSimpleRetrieve(
  stateToRequest(api.getWeeklyLostOppRevenue),
  STORE_WEEK_HOUR_DATA
)

export const retrievePnlWeekly = createSimpleRetrieve(
  stateToRequest(api.getPnlWeeklyData),
  STORE_PNL_WEEKLY_DATA
)

export const retrieveContribElements = () => (dispatch, getState) => {
  const targetInfo = getEntityTargetInfo(getState())
  return api
    .getContribKeys(targetInfo)()
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(data => dispatch(action(STORE_CONTRIB_KEYS, data)))
    .catch(error => {
      /* eslint-disable no-console */
      console.log('error retrieving from server', error)
      /* eslint-enable no-console */
    })
}

export const retrieveCAContribElements = () => (dispatch, getState) => {
  const targetInfo = getEntityTargetInfo(getState())
  return api
    .getCAContribKeys(targetInfo)()
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(data => dispatch(action(STORE_CA_CONTRIB_KEYS, data)))
    .catch(error => {
      /* eslint-disable no-console */
      console.log('error retrieving from server', error)
      /* eslint-enable no-console */
    })
}

export const retrieveKpiSpec = () => (dispatch, getState) => {
  const period = getPeriod(getState())
  const targetInfo = getEntityTargetInfo(getState())
  return api
    .getKpiSpec(targetInfo)(period)
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(data => dispatch(action(STORE_KPI_SPEC, data)))
    .catch(error => {
      /* eslint-disable no-console */
      console.log('error retrieving from server', error)
      /* eslint-enable no-console */
    })
}

export const retrieveGoals = () => (dispatch, getState) => {
  const targetInfo = getEntityTargetInfo(getState())
  dispatch(action(SET_LOADING, true))
  const year = getYear(getState())

  return retrieveUnitList(moment())(dispatch, getState)
    .then(_ => api.getKpiGoals(targetInfo)(year))
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(data => {
      const unitMap = getUnitMap(getState())
      // const kpiMap = getMetricDisplayMap(getState())
      dispatch(action(STORE_KPI_GOALS, { data, unitMap }))
      dispatch(action(SET_LOADING, false))
    })
    .catch(error => {
      /* eslint-disable no-console */
      console.log('error retrieving from server', error)
      /* eslint-enable no-console */
      dispatch(action(SET_LOADING, false))
    })
}

export const retrieveContrib = ({ retrieve, storeContrib, storeAggregate }) => (
  dispatch,
  getState
) => {
  const targetInfo = getEntityTargetInfo(getState())
  const period = getPeriod(getState())

  const groups = getGroups(getState())
  const selectedGroups = getSelectedGroups(getState())
  const unitList =
    selectedGroups.length === 0 || selectedGroups[0] === 'all'
      ? getUnitIds(getState())
      : R.chain(g => groups[g] || [], selectedGroups)

  /* eslint-disable no-console */
  dispatch(action(SET_LOADING, true))
  return retrieve(targetInfo)(period, unitList)
    .then(data => data.json())
    .then(data => {
      if (data.restfulStatus && data.restfulStatus === 'FAILURE') {
        console.log('error retrieving from server', data)
        dispatch(storeErrorAction(data))
        throw new Error(data)
      }
      return data
    })
    .then(raw => {
      const { contribution, aggregate } = raw
      dispatch(action(storeContrib, contribution))
      dispatch(action(storeAggregate, aggregate))
      dispatch(action(SET_LOADING, false))
    })
    .catch(error => {
      console.log('error retrieving from server', error)
      dispatch(action(SET_LOADING, false))
    })
  /* eslint-enable no-console */
}

export const retrieveKpiContrib = _ =>
  retrieveContrib({
    retrieve: api.getKpiContrib,
    storeContrib: STORE_KPI_CONTRIB,
    storeAggregate: STORE_KPI_AG,
  })

export const retrieveKpiCAContrib = _ =>
  retrieveContrib({
    retrieve: api.getKpiCAContrib,
    storeContrib: STORE_KPI_CA_CONTRIB,
    storeAggregate: STORE_KPI_CA_AG,
  })

export const setYear = year => action(STORE_YEAR, year)

export const popSelector = _ => action(SET_SHOW_SELECTOR, true)
export const hideSelector = _ => action(SET_SHOW_SELECTOR, false)
